import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMoon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="#4D4D4D"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m12.893 6.965.49-.102a.5.5 0 0 0-.973-.027l.483.13ZM9.034 3.107l.13.483a.5.5 0 0 0-.027-.972l-.103.49ZM12.5 8A4.5 4.5 0 0 1 8 12.5v1A5.5 5.5 0 0 0 13.5 8h-1Zm-.096-.932c.063.3.096.612.096.932h1c0-.39-.04-.77-.118-1.137l-.978.205Zm.006-.232a2.65 2.65 0 0 1-2.558 1.96v1a3.65 3.65 0 0 0 3.524-2.701l-.966-.259Zm-2.558 1.96a2.648 2.648 0 0 1-2.648-2.648h-1a3.648 3.648 0 0 0 3.648 3.648v-1ZM7.204 6.148a2.65 2.65 0 0 1 1.96-2.558l-.259-.966a3.65 3.65 0 0 0-2.701 3.524h1ZM8 3.5c.32 0 .631.033.932.096l.205-.978A5.52 5.52 0 0 0 8 2.5v1ZM3.5 8A4.5 4.5 0 0 1 8 3.5v-1A5.5 5.5 0 0 0 2.5 8h1ZM8 12.5A4.5 4.5 0 0 1 3.5 8h-1A5.5 5.5 0 0 0 8 13.5v-1Z" />
  </svg>
);
const Memo = memo(SvgMoon);
export default Memo;
